// Tabs/TabPanelContent.products.tsx
import React from 'react';
import MarketCBDTable from '../components/tabs/products/MarketCBDTable';
import PhysicalCharacterizationCBDTable from '../components/tabs/products/PhysicalCharacterizationCBDTable';
import ProductsAnalysisMethodTable from '../components/tabs/products/ProductsAnalysisMethodTable';
import ProductAnalysisValuesTable from '../components/tabs/products/ProductAnalysisValuesTable';
import ProductsAnalysisReportsTable from '../components/tabs/products/ProductAnalysisReportTable';
import MarketCBDCard from '../components/tabs/products/MarketCBD';
import PhysicalCharacterizationCard from '../components/tabs/products/PhysicalCharacterizationCBD';
import ProductAnalisysMethodCard from '../components/tabs/products/ProductsAnalysisMethod';
import ProductAnalisysReportCard from '../components/tabs/products/ProductAnalysisReport';
import ProductAnalisysValueCard from '../components/tabs/products/ProductAnalysisValue';
import DynamicTabContentTable from './DynamicTabContentTable';

interface TabPanelContentProps {
    dynamicCollections: any[];
}

const TabPanelContentProducts: React.FC<TabPanelContentProps> = ({ dynamicCollections }) => (
    <div className="row">
        <div className="col-9 col-sm-9">
            <MarketCBDTable header={'CBD Market'} eventGroupToTrigger={'products'} />
            <PhysicalCharacterizationCBDTable header={'Physical Charac. CBD Table'} eventGroupToTrigger={'products'} />
            <ProductsAnalysisMethodTable header={'List of Analysis Methods'} eventGroupToTrigger={'products'} />
            <ProductAnalysisValuesTable header={'List of Products Analysis Values'} eventGroupToTrigger={'products'} />
            <ProductsAnalysisReportsTable header={'List of Analysis Reports'} eventGroupToTrigger={'products'} />
            <DynamicTabContentTable dynamicCollections={dynamicCollections} tabName="products" />
        </div>
        <div className="col-3 col-sm-3">
            <MarketCBDCard header={'CBD Product'} eventGroupToTrigger={'products'} />
            <PhysicalCharacterizationCard header={'Physical Charac. CBD'} eventGroupToTrigger={'products'} />
            <ProductAnalisysMethodCard header={'Analysis Method'} eventGroupToTrigger={'products'} />
            <ProductAnalisysReportCard header={'Analysis Report'} eventGroupToTrigger={'products'} />
            <ProductAnalisysValueCard header={'Product Analysis'} eventGroupToTrigger={'products'} />
        </div>
    </div>
);

export default TabPanelContentProducts;
